export default __webpack_public_path__ + "static/media/notification-project.f2932b2f.svg";